$(function () {
  if (document.body.classList.contains('neos-backend')) {
    return $('.notice-box').show(0);
  }

  if (sessionStorage.getItem('dismissed-notice-box') != 'true') {
    setTimeout(function () {
      $('.notice-box').fadeIn(1500, 'swing', function () {
        $('.notice-box').one('click', '.dismiss-button', function (event) {
          $('.notice-box').fadeOut(700, 'swing', function () {
            sessionStorage.setItem('dismissed-notice-box', 'true');
            $('.notice-box').remove();
          });
        });
      });
    }, 1000);
  }
});